import {observable, action, runInAction} from "mobx"
import GenericFormStore from "../../../stores/FormStore";
import userStore from "../../../stores/UserStore";
import {go} from "../../../utils/navigationUtility";
import request from '../../../utils/request';
import {MANAGE_STUDENT_PUBLIC} from '../../../constants/urlConstants';

class ForgotPasswordStore extends GenericFormStore {
    @observable form = ForgotPasswordStore.initUploadTrackForm();
    @observable isProcessing = false;

    static initUploadTrackForm() {
        return {
            fields: {
                email: {
                    value: '',
                    error: '',
                    rule: 'required|email'
                }
            },
            meta: {
                isValid: false,
                error: null
            },
        };
    }

    @action handleSubmit = async () => {
        this.form.meta.isValid = false;
        let email = this.form.fields.email.value;

        try {
            this.isProcessing = true;
            await userStore.forgotPassword(email);
            go('auth/forgot-password/link-sent', {
                username: email
            });
            runInAction(() => {
                this.form.meta.isValid = true;
                this.isProcessing = false;
            });
        } catch (err) {
            if (err.code === 'NotAuthorizedException') {
                try {
                    await request(`${MANAGE_STUDENT_PUBLIC}/resend`, {method: 'POST', body: {email: email}});
                    go('auth/forgot-password/link-sent', {
                        username: email
                    });
                    runInAction(() => {
                        this.form.meta.isValid = true;
                        this.isProcessing = false;
                    });
                } catch (err) {
                    runInAction(() => {
                        this.form.meta.error = 'A problem was encountered trying to send the reset password link. Please try again';
                        this.form.meta.code = err.code;
                        this.form.meta.isValid = false;
                        this.isProcessing = false;
                    });
                }
            } else {
                runInAction(() => {
                    this.form.meta.error = err.code === 'UserNotFoundException' ? 'This email is not in the system. Please sign up or try another email.' : err.message;
                    this.form.meta.code = err.code;
                    this.form.meta.isValid = false;
                    this.isProcessing = false;
                });
            }
        }
    }
}

const forgotPasswordStore = new ForgotPasswordStore();
export default forgotPasswordStore;

